import { useEffect, useState } from 'react';

interface UseOwapInfoReturns {
  isOwap: boolean;
  owapWebviewType: OwapWebviewType | null;
}

type OwapWebviewType = 'page' | 'fullpage' | 'modal' | 'fullmodal';

export const useOwapInfo = (): UseOwapInfoReturns => {
  const [isOwap, setIsOwapApp] = useState(false);
  const [owapWebviewType, setOwapWebviewType] =
    useState<OwapWebviewType | null>(null);

  function isOwapApp(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }
    return sessionStorage.getItem('owapApp') === 'true';
  }

  function getOwapWebviewType(): OwapWebviewType | null {
    if (typeof window === 'undefined') {
      return null;
    }
    return (
      (sessionStorage.getItem('owapWebviewType') as OwapWebviewType) ?? null
    );
  }

  useEffect(() => {
    setIsOwapApp(isOwapApp());
    setOwapWebviewType(getOwapWebviewType());
  }, []);

  return {
    isOwap,
    owapWebviewType,
  };
};
